import * as React from 'react'

import { MobileHierarchy } from './MobileHierarchy'
import { DesktopHierarchy } from './DesktopHierarchy'
import * as cold from '@owl-nest/cold-data/client'

type HierarchyProps = {
  activeId?: string
  openId?: string
}

export function Hierarchy({ activeId, openId = activeId }: HierarchyProps) {
  const openTree = cold.getTree(cold.hierarchy, openId)

  if (openTree.type === 'product-type') {
    // product-type is the leaf of the tree. We have to keep open the parent
    // tree, to shopw all siblings product-types. In this case, open (the parent
    // of the product-type) != active (the currently selected product-type)
    return <Hierarchy activeId={activeId} openId={openTree.parents[openTree.parents.length - 1].id} />
  }

  return (
    <>
      <DesktopHierarchy tree={openTree} activeId={activeId} />
      <MobileHierarchy tree={openTree} />
    </>
  )
}
